@let controls = form.controls;

<div class="flex-1 min-h-0 overflow-auto px-[1.25rem] py-[1rem]"
     [formGroup]="form">
  <p-button [text]="true"
            severity="contrast"
            class="mb-[1rem] flex"
            styleClass="!gap-[0.25rem] !px-0 !py-0 !text-[0.75rem] !font-semibold !text-(--p-primary-500) !border-none hover:!text-(--p-sky-500)"
            (onClick)="cancel()">
    <svg-icon src="icons/icon-arrow-left.svg" name="icon-arrow-left" class="size-[1.25rem] shrink-0"></svg-icon>

    <span translate="@@fp-event-status-form__back"></span>
  </p-button>

  <div class="rounded-[0.5rem] bg-(--p-neutral-50) px-4 py-3">
    @if (isResultEdit) {
      <h3 class="text-[0.875rem] font-semibold leading-[150%] text-(--p-gray-950)">
        {{ resultEditTitle | translate }}
      </h3>
    } @else {
      <div class="flex flex-wrap items-center gap-[0.75rem]">
        <span class="text-[0.875rem] font-semibold leading-[150%] text-(--p-gray-950)"
              translate="@@fp-event-status-form__title"></span>

        <gc-dialog-event-badges [status]="dialogState.status()"
                                [investigationResult]="dialogState.investigationResult()"
                                [repairStatus]="dialogState.repairStatus()"></gc-dialog-event-badges>

        <svg-icon src="icons/icon-right.svg" name="icon-right" class="size-[1.25rem] shrink-0 text-(--p-blue-500)"></svg-icon>

        <gc-dialog-event-badges [status]="change.target"
                                [investigationResult]="change.investigationResult"
                                [repairStatus]="pendingRepairStatus()"></gc-dialog-event-badges>
      </div>
    }

    <p class="mt-[1.25rem] mb-1d text-[0.75rem] font-medium leading-[150%] text-(--p-gray-500)"
       translate="@@fp-event-form__description"></p>

    @if (hasRequiredFields()) {
      <p class="mt-[0.25rem] text-[0.75rem] font-medium leading-[150%] text-(--p-gray-500)">
        <span translate="@@fp-event-form__required-hint"></span>

        <span class="ml-[0.25rem] text-(--p-sky-500)">*</span>
      </p>
    }

    <div class="mt-[1rem] flex flex-col gap-[1rem]">
      @if (existingResultLabel; as resultLabel) {
        <div class="flex flex-col gap-[0.75rem] rounded-[0.5rem] border border-(--p-blue-50) bg-(--p-surface-0) px-[1rem] py-[0.75rem]">
          <span class="text-[0.8125rem] font-medium leading-[150%] text-(--p-gray-950)"
                translate="@@fp-event-status-form__existing-result"
                [translateParams]="{ I18N_VAR_RESULT: resultLabel | translate }"></span>

          <div class="flex flex-wrap items-center gap-[0.5rem]">
            @for (option of keepResultOptions; track option.value) {
              @let isPicked = controls.keepResult.value === option.value;

              <label class="flex cursor-pointer items-center gap-[0.5rem] rounded-[0.5rem] border bg-(--p-surface-0) px-[0.75rem] py-[0.5rem] text-[0.8125rem] font-semibold text-(--p-gray-950) hover:border-(--p-blue-100) hover:bg-(--p-neutral-500) [&:hover_.p-radiobutton-box]:[outline:1px_solid_var(--p-blue-100)] [&:hover_.p-radiobutton-box]:[outline-offset:2px]"
                     [class]="isPicked ? 'border-(--p-blue-300)' : 'border-(--p-blue-50)'"
                     [for]="'dialog-event-keep-result-' + option.value">
                <!-- no `name`: PrimeNG takes it from `formControlName`, and throws if the two differ -->
                <p-radioButton [inputId]="'dialog-event-keep-result-' + option.value"
                               formControlName="keepResult"
                               class="flex shrink-0"
                               [value]="option.value"></p-radioButton>

                <span [translate]="option.label"></span>
              </label>
            }
          </div>
        </div>
      }

      @if (change.form === FormKind.Assignee) {
        <div class="flex flex-col gap-[0.375rem]">
          <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)">
            <span translate="@@shared-events-assignee__text"></span>

            @if (isAssigneeRequired) {
              <span class="ml-[0.25rem] text-(--p-sky-500)">*</span>
            }
          </span>

          <p-select #assigneeSelect
                    panelStyleClass="p-special"
                    formControlName="assignedTo"
                    [styleClass]="'w-full p-special !h-[2.75rem]' + (hasError(controls.assignedTo) ? ' !border-(--p-other-red-500)' : '')"
                    [overlayOptions]="overlayOptions"
                    [options]="assigneeOptions()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'@@shared-events-not-assigned__text' | translate">
            <ng-template #item let-option>
              <div class="flex items-center gap-[0.5rem]">
                @if (option.value === controls.assignedTo.value) {
                  <svg-icon class="original-icon block shrink-0" src="icons/icon-checked.svg" name="icon-checked"></svg-icon>
                } @else {
                  <span class="block size-[1rem] shrink-0 rounded-full border border-(--p-gray-200)"></span>
                }
                <span>{{ option.label }}</span>
              </div>
            </ng-template>

            <ng-template #dropdownicon>
              @if (assigneeSelect.overlayVisible) {
                <svg-icon class="text-inherit" src="icons/icon-accordion-arrow-up.svg" name="icon-accordion-arrow-up"></svg-icon>
              } @else {
                <svg-icon class="text-inherit" src="icons/icon-accordion-arrow-down.svg" name="icon-accordion-arrow-down"></svg-icon>
              }
            </ng-template>
          </p-select>

          @if (hasError(controls.assignedTo)) {
            <span class="text-[0.75rem] font-medium text-(--p-other-red-500)"
                  translate="@@fp-event-validation__assignee"></span>
          }
        </div>
      }

      @if (controls.resolution && change.investigationResult) {
        <gc-dialog-event-resolution-fields [form]="controls.resolution"
                                           [result]="change.investigationResult"></gc-dialog-event-resolution-fields>
      }

      @if (change.comment) {
        @let commentTooLong = controls.comment.hasError('maxlength');

        @let isResolution = change.form === FormKind.Resolution;

        @if (isResolution) {
          <div class="h-[1px] w-full bg-(--p-primary-50)"></div>
        }

        <!-- under the resolution's row of three fields it is as wide as two of them -->
        <div class="flex flex-col gap-[0.375rem]"
             [class]="isResolution ? 'sm:w-[calc(200%/3-0.25rem)]' : ''">
          <label class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)"
                 for="dialog-event-status-comment">
            <span [translate]="commentWording.label"></span>
            @if (change.comment === CommentRequirement.Required) {<span class="ml-[0.25rem] text-(--p-sky-500)">*</span>}
          </label>

          <textarea id="dialog-event-status-comment"
                    pTextarea
                    rows="4"
                    formControlName="comment"
                    class="w-full resize-none !text-[0.75rem] !p-3 !font-medium placeholder:!text-(--p-gray-300)"
                    [class]="hasError(controls.comment) || commentTooLong ? '!border-(--p-other-red-500)' : ''"
                    [placeholder]="commentWording.placeholder | translate"></textarea>

          @if (hasError(controls.comment) && !commentTooLong) {
            <span class="text-[0.75rem] font-medium text-(--p-other-red-500)"
                  [translate]="commentWording.requiredError"></span>
          }

          @if (commentTooLong) {
            <span class="text-[0.75rem] font-medium leading-[150%] text-(--p-other-red-500)"
                  translate="@@edit-comment-characters-error"
                  [translateParams]="{ I18N_VAR_MAX: maxCommentLength }"></span>
          } @else {
            <span class="text-[0.75rem] font-medium leading-[150%] text-(--p-gray-500)"
                  translate="@@edit-comment-characters"
                  [translateParams]="{ I18N_VAR_CURRENT: controls.comment.value.length, I18N_VAR_MAX: maxCommentLength }"></span>
          }
        </div>
      }
    </div>
  </div>
</div>

<div class="flex shrink-0 flex-col items-center gap-[0.75rem] border-t border-t-(--p-primary-50) px-[1.25rem] py-[0.875rem] sm:flex-row sm:flex-wrap sm:justify-between">
  <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
        translate="@@fp-event-form__not-saved-hint"></span>

  <!-- stacked and full width on a phone -->
  <div class="flex items-center gap-[0.25rem] max-sm:w-full max-sm:flex-col max-sm:items-stretch">
    <p-button [outlined]="true"
              class="max-sm:w-full"
              styleClass="!h-[2rem] !px-[1rem] !font-semibold !rounded-[0.25rem] !border-(--p-primary-500) !text-(--p-primary-500) max-sm:!w-full"
              [label]="'@@shared-cancel__text' | translate"
              (onClick)="cancel()"></p-button>

    <p-button class="max-sm:w-full"
              styleClass="!h-[2rem] !px-[1rem] !font-semibold !rounded-[0.25rem] max-sm:!w-full"
              [label]="change.confirmLabel | translate"
              [disabled]="form.invalid || isUnchanged()"
              [loading]="dialogState.isSaving()"
              (onClick)="confirm()"></p-button>
  </div>
</div>
